import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SponsorInterface } from 'src/app/types/sponsor';

@Component({
  selector: 'app-sponsor-strip',
  templateUrl: './sponsor-strip.component.html',
  styleUrls: ['./sponsor-strip.component.scss'],
})
export class SponsorStripComponent implements OnInit {
  @Input()
  sponsorStrip: SponsorInterface;

  constructor(private router: Router) {}

  goToUrl() {
    let url = this.sponsorStrip.url;

    if (
      (this.sponsorStrip.newWindow || url.indexOf('//') > -1) &&
      typeof window !== 'undefined'
    ) {
      window.open(url, '_blank');
    } else {
      this.router.navigateByUrl(url);
    }
  }

  ngOnInit() {}
}
